<template>
  <div class="join-company">
    <div class="el-icon-back back" @click="back"><span>加入企业</span></div>
    <div class="body">
      <div class="title">填写企业编号</div>
      <el-form label-width="80px" label-position="left">
        <el-form-item label="企业编号">
          <el-input
            class="join-input"
            v-model="companyCode"
            placeholder="请输入企业编号"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button class="join-button" @click="join">申请加入</el-button>
    </div>
  </div>
</template>
<script>
import { joinCompany } from "@/api/userCenter/company"
export default {
  name: "Join-company",
  data() {
    return {
      companyCode: ""
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    join() {
      if (!this.companyCode) return this.$message.error("请输入企业编码")
      joinCompany(this.companyCode).then(() => {
        this.$message.success("申请成功")
        this.$router.push({ name: "selectCompany" })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.join-company {
  height: 100vh;
  width: 100%;
  background: #f5f5f5;
  @include flex-center;
  .back {
    position: fixed;
    z-index: 10;
    left: 40px;
    top: 48px;
    font-size: 18px;
    color: #606266;
    line-height: 28px;
    cursor: pointer;
    span {
      margin-left: 5px;
    }
  }
  .body {
    width: 428px;
    padding: 48px 36px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 20px 4px rgba(192, 196, 204, 0.3);
    display: flex;
    flex-flow: column;
    .title {
      font-size: 18px;
      color: #606266;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 32px;
    }
    .join-button {
      width: 320px;
      height: 42px;
      background: #1989fa;
      box-shadow: 0 2px 8px 1px rgb(25 137 250 / 30%);
      border-radius: 6px;
      color: #ffffff;
      font-size: 16px;
      margin-top: 40px;
      align-self: center;
    }
  }
}
</style>
